import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

import * as admin from 'firebase-admin';
import * as fireorm from 'fireorm';


import google from 'googleapis';
import { UserModel, UserRepo } from 'types/models/dataAccess/User';
// import { SpaceRepo } from 'types/models/dataAccess/Space';
import { getRepository } from 'fireorm';

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCW57kI8rJSxzpmfjEw5YG64jTjiPFdSUg",
  authDomain: "fablabcoa.firebaseapp.com",
  projectId: "fablabcoa",
  storageBucket: "fablabcoa.appspot.com",
  messagingSenderId: "843411513776",
  appId: "1:843411513776:web:2d97eb49e549eb3f317675",
  measurementId: "G-T5FRRKWHP4"
};

if (!firebase.apps.length) {

// const serviceAccount = require('keys/firebaseAdmin.json');

// admin.initializeApp({
//   credential: admin.credential.cert(serviceAccount),
//   databaseURL: `https://${serviceAccount.project_id}.firebaseio.com`,
// });

// const firestoreOrm = admin.firestore();
// fireorm.initialize(firestoreOrm);
  firebase.initializeApp(firebaseConfig);
  console.log("firebase inited")
}

const auth = firebase.auth();



const firestore = firebase.firestore();
const storage = firebase.storage();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const userRepo = new UserRepo();
// const spaceRepo = new SpaceRepo();

// const userRepo = getRepository(UserModel);
// const spaceRepo = getRepository(SpaceModel);


// const authGoogle = new google.auth.GoogleAuth({
//   keyFile: 'spatialthink-075d7f97c6a8.json',
//   scopes: ['https://www.googleapis.com/auth/cloud-platform'],
// });

// gapi.client.load('sqladmin', 'v1beta4', function() { console.log('loaded');});
// gapi.client.sql.instances.list({'project': PROJECT_ID}).execute(showResult);
// function showResult(result) {
//   // Process the result.
// };

export {
  auth,
  firestore,
  storage,
  userRepo,
  // spaceRepo,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider,
};

